export default "__VITE_ASSET__DTWRB9sn__"